import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableContainer
} from '@mui/material'
import styled from 'styled-components'
import { COLORS, FONTS, SPACING, TYPOGRAPHY } from 'utils'

const TableContainerStyled = styled(TableContainer)`
  margin-top: ${SPACING.spacing15};
`

export interface ITable {
  width?: string
}
const TableStyled = styled(Table) <ITable>`
  width: ${({ width }) => width || '100%'};
`

export interface ITableHead {
  backgroundColor?: string
  textColor?: string
}
const TableHeadStyled = styled(TableHead) <ITableHead>`
  tr {
    box-shadow: inset 0px -1px 0px rgba(102, 102, 102, 0.08);
    background: ${({ backgroundColor }) =>
    backgroundColor || COLORS.tableColor};
  }
  th {
    padding: 0 4px 0 4px;
    margin: 0;
    height: 36px;
    color: ${({ textColor }) => textColor || COLORS.blueFonts};
    font-size: ${TYPOGRAPHY.bodySize14};
    font-weight: ${FONTS.bold};
    font-family: Arial;

    :first-child {
      border-radius: 2px 0 0 0;
    }
    :last-child {
      border-radius: 0 2px 0 0;
    }
  }
`

const TableBodyStyled = styled(TableBody)`
  td {
    padding: 0 4px 0 4px;
    margin: 0;
    height: 36px;
    color: ${COLORS.black};
    font-family: Arial;
    font-size: ${TYPOGRAPHY.bodySize13};
    font-weight: ${FONTS.bold};
  }
`

interface ITableRowStyled {
  backgroundColor?: string
}

const TableRowStyled = styled(TableRow) <ITableRowStyled>`
  && {
    background-color: ${({ backgroundColor }) => backgroundColor || ''};
  }
`

interface ITableCell {
  minwidth?: string
  maxwidth?: string
  status?: boolean
  hasNoPointer?: boolean
  multiIcon?: boolean
  backgroundColor?: string
  textColor?: string
  style?: React.CSSProperties
  wordWrap?: boolean;
}

const TableCellStyled = styled(TableCell) <ITableCell>`
  && {
    min-width: ${({ minwidth }) => minwidth};
    max-width: ${({ maxwidth }) => maxwidth};
    color: ${({ textColor }) => textColor || COLORS.black};
    background: ${({ backgroundColor }) => backgroundColor || ''};
    ${({ hasNoPointer }) => (hasNoPointer ? '' : 'cursor: pointer')}
    ${({ status }) => status && `text-align: -webkit-center;`}
    ${({ multiIcon }) => multiIcon && 'display: flex'}
    ${({ wordWrap }) => wordWrap && 'word-wrap: break-word;'}
  }
`

export {
  TableCellStyled,
  TableRowStyled,
  TableBodyStyled,
  TableStyled,
  TableHeadStyled,
  TableContainerStyled
}
